import React from 'react';

import { Toggle } from 'components/Toggle';
import { TRACKING_ALL_ORDERS_FEE_USD } from './trackingBillingFeatures';

interface TrackingBillingSettingsProps {
  enabled: boolean;
  loading: boolean;
  disabled?: boolean;
  onChange: (enabled: boolean) => void;
}

export const TrackingBillingSettings = ({
  enabled,
  loading,
  disabled = false,
  onChange,
}: TrackingBillingSettingsProps) => (
  <section className="bg-white rounded-lg border border-[#e1e3e5] p-6">
    <div className="flex flex-col gap-5 md:flex-row md:items-start md:justify-between">
      <div className="max-w-2xl">
        <h2 className="text-base font-semibold text-[#202223] mb-1">
          Order tracking coverage
        </h2>
        <p className="text-[#6d7175] text-sm">
          Guaranteed and Return shipments always include ShipAid tracking at no
          extra cost.
        </p>

        <div className="mt-4 flex items-baseline gap-2">
          <span className="text-[22px] font-semibold text-[#202223] leading-none">
            {`$${TRACKING_ALL_ORDERS_FEE_USD.toFixed(2)}`}
          </span>
          <span className="text-[#6d7175] text-sm">
            per non-Guaranteed outbound order
          </span>
        </div>
        <p className="text-[#6d7175] text-sm mt-2">
          Charged only when you opt in to tracking every outbound order.
          Included shipment types stay free.
        </p>
      </div>

      <div className="flex-shrink-0 md:pl-6 md:border-l md:border-[#e1e3e5] md:self-stretch md:flex md:flex-col md:justify-center">
        <Toggle
          isEnabled={enabled}
          onChange={onChange}
          disabled={disabled || loading}
          ariaLabel="Track all outbound orders"
          rightLabel="Track all outbound orders"
        />
        <p
          className={`mt-2 text-xs ${
            loading ? 'text-[#6d7175]' : 'text-transparent'
          }`}
          role="status"
        >
          {loading ? 'Saving tracking preference…' : 'placeholder'}
        </p>
      </div>
    </div>
  </section>
);
